/** Indian-market OI formatting: crores / lakhs. Shared by the OI ladders
 * and the OI-change trend charts so both always read the same way. */

export function formatOi(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1e7) return `${(abs / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `${(abs / 1e5).toFixed(1)} L`;
  return abs.toLocaleString("en-IN");
}

export function formatSignedOi(value: number): string {
  return `${value < 0 ? "-" : "+"}${formatOi(value)}`;
}
